
import React, { useState } from 'react';
import ReactDOM from "react-dom";
import { axiosInstance } from '../utils';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const EditFeeModal = ({cancel, update}) => {

    const [feeName, setFeeName] = useState("");
    const [feeValue, setFeeValue] = useState("");

      const token = localStorage?.getItem("token");

   const onUpdate = () => {
    const data = {
      feeName,
      feeValue
    }
    return update(data);
   }

  //  const updateFee = async () => {
  //   if(!feeName) {
  //       toast.error("Please, Select Fee Name",
  //           {
  //             position: "top-right",
  //             autoClose: 5000,
  //             theme: "light",
  //             hideProgressBar: true,
  //           }
  //         );
  //   } else if(!feeValue) {
  //       toast.error("Please, Enter Fee Value",
  //           {
  //             position: "top-right",
  //             autoClose: 5000,
  //             theme: "light",
  //             hideProgressBar: true,
  //           }
  //         );
  //   } else if(!feeName && !feeValue) {
  //       toast.error("Please, Enter Values",
  //           {
  //             position: "top-right",
  //             autoClose: 5000,
  //             theme: "light",
  //             hideProgressBar: true,
  //           }
  //         );
  //   } 
  //   else {
  //    try {
  //      const data = {
  //       feeName: feeName,
  //       feeValue: feeValue
  //      } 
  //       await axiosInstance.post("/api/update-fee", data,{
  //           headers: {
  //               Authorization: `Bearer ${token}`
  //           }
  //       })
  //       .then(res => {
  //           toast.success("Fee Update Successfully!",
  //           {
  //             position: "top-right",
  //             autoClose: 5000,
  //             theme: "light",
  //             hideProgressBar: true,
  //           }
  //         ); 
  //       })
  //       .catch(err => {
  //           toast.error(err.response.data.message,
  //   {
  //     position: "top-right",
  //     autoClose: 5000,
  //     theme: "light",
  //     hideProgressBar: true,
  //   }
  // );
  //       })

  //    } catch (error) {
  //       toast.error(error,
  //           {
  //             position: "top-right",
  //             autoClose: 5000,
  //             theme: "light",
  //             hideProgressBar: true,
  //           }
  //         );
  //    }
  //   }
  //  }
  
   const handleFeeName = (e) => {
     setFeeName(e.target.value);
   }

   const handleFeeValue = (e) => {
    let value = e.target.value;
   
    const regex = /^[0-9(\.)\s]+$/;
    if(value.match(regex) || value === "") {
        setFeeValue(value);
    }

    };

  
  return ReactDOM.createPortal(  <div
    className="fixed inset-0 flex items-center justify-center overflow-hidden rounded-md"
  >
    <div className="fixed inset-0 z-10 overflow-hidden bg-black opacity-50"></div>
    <div className="fixed top-0 left-0 z-20 flex h-full w-full items-center justify-center">
      <div className="relative max-h-[90vh] max-w-[90vw] rounded-lg bg-white p-6 sm:max-w-[80vw]">
        <div className='p-2'>
          <h1 className='heading-one !text-center !pb-3'>Edit Fee</h1>

          <div className='space-y-6'>
            <div className='space-y-4'>
              <div className='flex flex-col gap-1'>
                <label htmlFor='fee name' className='font-poopins text-sm font-medium text-secondary-n-200'>Please Select Fee Name:</label>
                <select className='outline-none pl-3 rounded-md  h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins w-full placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm ' onChange={handleFeeName}>
                    <option value={""}>Please Select</option>
                    <option value={"buyServiceFee"}>Buy Service Fee</option>
                    <option value={"sstTaxFee"}>SST Tax Fee</option>
                    <option value={"storageInsuranceChargesFee"}>Storage Insurance Charges Fee</option>
                    <option value={"sellServiceFee"}>Sell Service Fee</option>
                    <option value={"sendGoldServiceFee"}>Send Gold Service Fee</option>
                    <option value={"redeemPickupDeliveryFee"}>Redeem Pickup Delivery Fee</option>
                    <option value={"redeemDeliveryDeliveryFee"}>Redeem Delivery Delivery Fee</option>
                    <option value={"redeemDeliveryServiceFee"}>Redeem Delivery Service Fee</option>
                    <option value={"redeemPickupServiceFee"}>Redeem Pickup Service Fee</option>
                </select>
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='feevalue' className='font-poopins text-sm font-medium text-secondary-n-200'>Fee Value</label>
                <input type='text' value={feeValue}  min={0}  name='feevalue' onChange={handleFeeValue}
                 placeholder='1.0'
                  className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              
              </div>
            </div>
           
              <div className='flex items-center gap-2'>
                <button className='font-poppins h-10 w-[250px] text-secondary-n-90 outline-none bg-white border-[1px] border-secondary-n-90 flex justify-center items-center rounded-md' onClick={cancel}>Cancel</button>
                <button className='font-poppins h-10 w-[250px] text-white outline-none bg-primary-yellow-500 flex justify-center items-center rounded-md' onClick={onUpdate}>Update</button>
              </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  </div>, document.body)
}

export default EditFeeModal;